export default __webpack_public_path__ + "slices/main/assets/public/fonts/camper/camper-regular.b8c2dd84222eca7130d43009daf2635c.woff2";